import React, { useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Button, Modal, TextField } from '@mui/material'
import { withTranslation } from 'react-i18next'
import { Autocomplete } from '@mui/material'

function getModalStyle() {
   return {
      top: `${50}%`,
      left: `${50}%`,
      transform: `translate(-${50}%, -${50}%)`,
   }
}

const useStyles = makeStyles(theme => ({
   paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
   },
   body: {
      marginBottom: '20px',
   },
   buttonsPosition: {
      float: 'right',
   },
}))

const SkillModal = ({
   skill,
   openModal,
   toggleModal,
   editSkillName,
   editSkillProperty,
   createEditSkill,
   skillGroups,
   t,
}) => {
   const classes = useStyles()
   const [modalStyle] = React.useState(getModalStyle)
   const [error, setError] = useState(false)

   const handleChangeSkillGroup = (e, option) => {
      if (option !== null) {
         editSkillProperty('GroupName', option.Name)
         editSkillProperty('GroupID', option._id)
      }
   }

   const handleSubmit = () => {
      if (skill.Name === '') {
         setError(true)
         return
      }
      createEditSkill()
   }

   return (
      <Modal
         open={openModal}
         onClose={() => {
            setError(false)
            toggleModal()
         }}
         aria-labelledby="simple-modal-title"
         aria-describedby="simple-modal-description"
      >
         <div style={modalStyle} className={classes.paper}>
            <div className={classes.body}>
               <h5 id="simple-modal-title">
                  {skill._id ? t('editModalSkillTitle') : t('createModalSkillTitle')}
               </h5>
               <TextField
                  id="standard-basic"
                  variant={'outlined'}
                  placeholder={t('namePlaceholder')}
                  value={skill.Name}
                  onInput={e => {
                     editSkillName(e.target.value)
                     if (e.target.value !== '') {
                        setError(false)
                     } else {
                        setError(true)
                     }
                  }}
                  error={error}
                  label={error ? t('createModalSkillError') : t('namePlaceholder')}
                  style={{ width: '100%' }}
               />
            </div>
            {skill._id && (
               <div className={classes.body}>
                  <Autocomplete
                     value={skill.GroupName}
                     defaultValue={{ Name: skill.GroupName }}
                     options={skillGroups}
                     getOptionLabel={option => option.Name ?? option}
                     onChange={(e, option) => handleChangeSkillGroup(e, option)}
                     isOptionEqualToValue={(option, value) => option.Name === value}
                     disableClearable
                     className={classes.mainAutocomplete}
                     renderInput={params => (
                        <TextField
                           {...params}
                           label={t('filterAccordionTextSkillGroup')}
                           variant={'outlined'}
                        />
                     )}
                  />
               </div>
            )}
            <div className={classes.buttonsPosition}>
               <Button
                  onClick={handleSubmit}
                  size="small"
                  variant="contained"
                  color="primary"
                  disabled={error}
               >
                  {t('saveButtonTitle')}
               </Button>
               <Button
                  onClick={() => {
                     setError(false)
                     toggleModal()
                  }}
                  color={'secondary'}
                  sx={{ color: 'black' }}
               >
                  {t('cancelButtonTitle')}
               </Button>
            </div>
         </div>
      </Modal>
   )
}

export default withTranslation()(SkillModal)
